import React, { useState, useEffect } from 'react';
import './Navigation.css';
import brandMark from '../assets/ob-monogram.svg';

const Navigation = ({ activeSection, simple = false }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'philosophie', label: 'Philosophie' },
    { id: 'about', label: 'Über mich' },
    { id: 'leistungen', label: 'Leistungen' },
    { id: 'ersttermin', label: 'Ersttermin' },
    { id: 'preise', label: 'Preise & Referenzen' },
    { id: 'kontakt', label: 'Termin vereinbaren' },
  ];

  return (
    <nav className={`nav-header ${isScrolled ? 'scrolled' : ''} ${simple ? 'nav-simple' : ''}`}>
      <div className={`nav-wrapper ${simple ? 'nav-wrapper-simple' : 'nav-wrapper-default'}`}>
        <div className="nav-content">
          {!simple && (
            <div className="nav-links">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          )}
        </div>
        <div className={`nav-logo ${simple ? 'nav-logo--center' : ''}`}>
          <img
            src={brandMark}
            alt="Sportphysiotherapie Oliver Bauer – Logo"
            className="logo-icon"
          />
          <div className="logo-divider" aria-hidden="true"></div>
          <div className="logo-text">
            <span className="logo-title">Oliver Bauer</span>
            <span className="logo-subtitle">Sportphysiotherapie</span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
